const setup_dropdown_records = {
  dropdownTables: (tableList) => ({ type: "SET_DROPDOWN_RECORD_TABLES", payload: tableList }),
  dropdownTableData: (tableData) => ({ type: "SET_DROPDOWN_TABLE_DATA", payload: tableData }),
  dropdownTableColumns: (tableColumns) => ({ type: "SET_DROPDOWN_TABLE_COLUMNS", payload: tableColumns }),
  dropdownTablePagination: (paginationData) => ({ type: "SET_DROPDOWN_TABLE_PAGINATION", payload: paginationData }),
};

export default setup_dropdown_records;
